(function () {
    'use strict';

    angular.module("imApp").factory("freightRateSetService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1542,
                    parameters: parms || {}
                });
            },
            listFreightRateSets: function (parms) {
                return $ihttp.post({
                    method: 1546,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
